import React, { useEffect, useState } from "react";
import DefaultModal from "../DefaultModal.jsx";
import LoaderContainer from "../../mui/loader_container/LoaderContainer.jsx";
import { API_USER } from "../../../api/user.js";
import { useTranslation } from "react-i18next";
import { TEST_MODE } from "../../../store/enums.js";
import { testDetailBalance } from "../../../store/testConst.js";
import useBalance from "../../../hooks/useBalance.js";
import ShowContainer from "../../mui/ShowContainer.jsx";
import { useAppSelector } from "../../../store/index.ts";
import "./detail-balance.scss";

export default function DetailBalance({ isOpen, closeModal }) {
  const { t } = useTranslation();
  const { mainBalance, bonusBalance } = useBalance();
  const currency = useAppSelector((state) => state.user.currency);
  const [loader, setLoader] = useState(true);
  const [balance, setBalance] = useState({});

  const balanceString = mainBalance?.toLocaleString();
  const bonusBalanceString = bonusBalance?.toLocaleString();
  const openForPayout = balance.openForPayout?.toLocaleString();

  const detailDepositBalance = balance.depositBalance;
  const detailBonusBalance = balance.bonusBalance;
  const isDetailBalance = detailDepositBalance?.length || detailBonusBalance?.length;

  useEffect(() => {
    setLoader(true);
    setBalance({});

    if (!isOpen) return;
    if (TEST_MODE) {
      setBalance(testDetailBalance);
      setLoader(false);
      return;
    }

    API_USER.balance
      .detail({ currency })
      .then((e) => {
        const data = e.data;
        setBalance(data);
      })
      .catch(console.error)
      .finally(() => setLoader(false));
  }, [isOpen, currency]);

  const CurrencyEl = ({ val }) => (
    <span className="currency">
      {(+val)?.toLocaleString()} {currency}
    </span>
  );

  return (
    <DefaultModal isOpen={isOpen} closeModal={closeModal} classModal="detail-balance-modal">
      <LoaderContainer loader={loader} center>
        <h2>
          {t("Main balance _", { balance: balanceString + " " + currency })}
          <ShowContainer condition={isDetailBalance}>
            <span> {t("consists of:")}</span>
          </ShowContainer>
        </h2>
        <section className="detail">
          <ShowContainer condition={detailDepositBalance?.length}>
            {detailDepositBalance?.map((el, indx) => (
              <div key={indx}>
                <CurrencyEl val={el.amount} /> - {t("wager")} x{el.wager} - {t("left to wager")}{" "}
                <CurrencyEl val={el.remained} />
              </div>
            ))}
          </ShowContainer>

          <ShowContainer condition={openForPayout}>
            <div>
              {openForPayout} {currency} - <span className="currency">{t("open for payment")}</span>
            </div>
          </ShowContainer>

          <article className="bonus__block">
            <h2> {t("Bonus balance _", { balance: bonusBalanceString + " " + currency })}</h2>
            <ShowContainer condition={detailBonusBalance?.length}>
              {detailBonusBalance?.map((el, indx) => (
                <div key={indx}>
                  <CurrencyEl val={el.amount} /> - {t("wager")} x{el.wager} - {t("cashout")} x
                  {el.cashout} - {t("left to wager")} <CurrencyEl val={el.remained} />
                </div>
              ))}
            </ShowContainer>
          </article>

          <ShowContainer condition={isDetailBalance}>
            <div className="detail__info">
              <span>
                {t(
                  "The amounts are shown from top to bottom, in the order in which the bet would be placed per spin in the game."
                )}
              </span>
            </div>
          </ShowContainer>
        </section>
      </LoaderContainer>
    </DefaultModal>
  );
}
